// @flow

const DIVIDER_SIZE = 7;

export const calcMaxCrumbs = (namesList: string[] = [], isShortSpace: boolean) => {
	const maxCharacters = isShortSpace ? 50 : 75;
	let charactersCount = 0;
	let crumbsCount = 0;

	if (namesList.length) {
		crumbsCount = 1;
		charactersCount = namesList[0].length;

		if (namesList.length > 1) {
			crumbsCount = 2;
			// first and last crumbs are always shown so they are the first to be calculated.
			charactersCount += namesList[namesList.length - 1].length + DIVIDER_SIZE;

			while (crumbsCount < namesList.length && charactersCount < maxCharacters) {
				charactersCount += namesList[crumbsCount - 1].length + DIVIDER_SIZE;
				crumbsCount++;
			}

			// when original path is longer than available space,
			// one crumbs is been deducted to accommodate space for the hidden crumbs indicator >...>
			crumbsCount = (crumbsCount > 2 && crumbsCount < namesList.length) ? crumbsCount - 1 : crumbsCount;
		}
	}

	return crumbsCount;
};
